import { pureRenderProps } from "@type-r/react";
import {
  asTimelessDate,
  CollapsableSection,
  Column,
  Columns,
  FormInput,
  ReadOnly,
  TopSection
} from "lqx-react";
import * as React from "react";
import { useContext } from "react";
import { OrderModel } from "api";
import { ComponentsSection } from "../../../../../common";

export const OrderManagement = ({
  order,
  fetched
}: {
  order: OrderModel;
  fetched: OrderModel;
}) => {
  const readOnly = useContext(ReadOnly) || !order.isWriteSupplier;
  const wfDescription = order.workflowMap && order.workflowMap.description;
  return (
    <TopSection id="order-management" title="Order Management">
      <CollapsableSection id="po-details" title="PO details" info={order.po_number} >
        <Columns>
          <Column>
            <FormInput label="Model" value={wfDescription} />
            <FormInput label="PO Date" value={asTimelessDate(order.po_details.po_date)} />
          </Column>
          <Column>
            <FormInput label="End Customer ID" $value={order.po_details.$.end_customer_id} />
            <FormInput label="Internal ID" value={order.po_details.internal_id} />
            <FormInput label="End Customer PO#" $value={order.$.end_customer_po} />
          </Column>
          {order.metadata && order.metadata.so_type ? (
            <Column>
              <FormInput label="SO Type" value={order.metadata.so_type} />
              <FormInput label="PO Type" value={order.metadata.po_type} />
            </Column>
          ) : null}
          {order.metadata && order.metadata.opportunity_id ? (
            <Column>
              <FormInput label=" Opportunity ID" value={order.metadata.opportunity_id} />
              <FormInput label="Ref. Sales Order" value={order.metadata.ref_sales_order_id} />
            </Column>
          ) : null}
        </Columns>
      </CollapsableSection>

      <QuotesSection quote={order.quote} />

      <ReadOnly.Provider value={readOnly}>
        <ComponentsSection
          parts={order.parts}
          originalParts={fetched.parts}
          disableQuantityCheck
        />
      </ReadOnly.Provider>
    </TopSection>
  );
};

const QuotesSection = pureRenderProps(
  {
    quote: OrderModel.attributes.quote
  },
  ({ quote }) => (
    <CollapsableSection id="quote-details" title="Quote" info={quote.id}>
      <Columns>
        <Column>
          <FormInput label="Quote Date" value={asTimelessDate(quote.date)} />
          <FormInput label="Order Number" value={quote.order_id} />
        </Column>
        <Column>
          <FormInput
            label="Transaction Date"
            value={asTimelessDate(quote.transaction_time)}
          />
        </Column>
      </Columns>
    </CollapsableSection>
  )
);
